// extracted by mini-css-extract-plugin
export default {"divider":"divider--FFCveG3nUiPHIspf2X3H"};